/**
 * PegTracker manages front and rear peg positions for all seats/teams.
 */
export class PegTracker {
  constructor() {
    this.positions = {};
    this.reset();
  }

  reset() {
    const seats = ['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7', 'p8', 'team1', 'team2', 'team3', 'team4', 'you', 'cpu'];
    this.positions = {};
    for (const s of seats) {
      this.positions[s] = { front: 0, rear: 0 };
    }
  }

  getPosition(seatId) {
    if (!this.positions[seatId]) {
      this.positions[seatId] = { front: 0, rear: 0 };
    }
    return this.positions[seatId];
  }

  getFront(seatId) {
    return this.getPosition(seatId).front;
  }

  getRear(seatId) {
    return this.getPosition(seatId).rear;
  }

  advance(seatId, newScore) {
    const pos = this.getPosition(seatId);
    const prevFront = pos.front;
    const safeRear = (newScore < prevFront) ? Math.max(0, newScore - 1) : prevFront;
    pos.rear = safeRear;
    pos.front = newScore;
    return pos;
  }

  toPlain() {
    return JSON.parse(JSON.stringify(this.positions));
  }
}
